import { render, staticRenderFns } from "./ConsulsList.vue?vue&type=template&id=1ff69638&scoped=true&"
import script from "./ConsulsList.vue?vue&type=script&lang=js&"
export * from "./ConsulsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff69638",
  null
  
)

export default component.exports